import { Component } from "@angular/core";
import { IonicPage, NavParams } from "ionic-angular";

@IonicPage()
@Component({
  selector: "prn-comment-popover",
  templateUrl: "prn-comment-popover.html",
})
export class PrnCommentPopover {
  prnComment: string;

  constructor(public navParams: NavParams) {
    this.prnComment = this.navParams.data.comment;
  }
}



// WEBPACK FOOTER //
// ./src/pages/assessment/prn-comment-popover/prn-comment-popover.ts